module.exports = __webpack_public_path__ + "static/media/matt.3070413c.png";